import { forwardRef, Icon, Input, InputGroup, InputProps, InputRightElement } from '@chakra-ui/react';

import SearchIcon from '@/assets/icons/ic-search.svg';

type IComboboxProps = InputProps;

export const FilterComboboxInput = forwardRef<IComboboxProps, 'input'>((props, ref) => {
  const { value, ...rest } = props;

  return (
    <InputGroup>
      <Input variant="flushed" {...rest} ref={ref} />
      <InputRightElement minW="max-content">
        <Icon as={SearchIcon} color="black" boxSize="24px" />
      </InputRightElement>
    </InputGroup>
  );
});
